import { Box, Button, Grid, styled, Typography } from "@mui/material";
import AuthenticateLayout from "../../components/AuthenticateLayout";
import QRCodeScanDialog from "../../components/QRCodeScanDialog";
// import RewardButton from "../../components/RewardButton";
import { useEffect, useState } from "react";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";
import GiftIcon from "../../assets/icons/gift2.svg";
import QRScanner from "../../components/QRCodeScanner";
import { ExpiredDate, ViewMoreBtn } from "../multi-coupons/MultiCoupons.styles";
import SVG from "react-inlinesvg";
import { links } from "../../constants/links";
import { useLocation, useNavigate } from "react-router-dom";
import { ReportErrorLink } from "../../components/ReportErrorLink";
import { getAdsDetail, postEngageAction, getCustomerSubcampaignStatus } from "../../services/ads/ads.service";
import { Loading } from "../../components";
import { commonDateFormat } from "../../utils/date-format";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { isExpiredToday } from "../../utils/utils";
import { toInteger } from "lodash";
import { LOGIN_METHOD } from "../../constants";
import isURL from "validator/lib/isURL";
import { TnC } from "../../components/TnC";


const UseRewardWrapper = styled(Box)({
  width: "100%",
  "& .body": {
    position: "absolute",
    width: "100%",
    paddingBottom: 20,
    "& .footerBox": {
      margin: "0 calc((100% - 333px) / 2)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: 15,
      ".notice_text": {
        fontWeight: 500
      },
      "& .notice": {
        color: "#DA314F"
      }
    },
  }
});

const QRCodeWrapper = styled(Box)({
  width: 333,
  height: 365,
  borderRadius: "10px",
  background: "#fff",
  margin: "0 calc((100% - 333px) / 2)",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  border: "1px solid #EBEBEB",
  boxShadow: "0px 19px 38px rgba(58, 76, 130, 0.1)",
  padding: 20,
});

const RedeemCode = styled(Typography)({
  fontSize: 18,
  lineHeight: "21px",
  letterSpacing: "2px",
  color: "#000000"
});

const ScanToRedeemButton = styled(Button)({
  width: "100%",
  fontSize: 14,
  lineHeight: "17px",
  fontWeight: 300,
  height: 48,
  position: "sticky",
  bottom: 20,
  "& .MuiButton-startIcon": {
    marginRight: 0
  },
  "svg": {
    marginTop: 3,
    width: 41,
    height: 41
  }
});

// const ListingAvatar = styled(Avatar)({
//   width: 24,
//   height: 24,
//   backgroundColor: "#42e0f5",
//   color: "white",
//   margin: "5px 0 5px 15px"
// });

export const NotificationWrapper = styled(Box)(`
  margin: 0 calc((100% - 333px) / 2);
  background-color: #FDEFE8;
  border: 1px dashed rgba(239, 91, 27, 0.5);
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 15px;
  display: flex;
  align-items: center;
  & .detail {
    color: #333333;
    font-size: 12px;
  };
  & .viewOtherBtn {
    font-size: 12px;
    font-weight: 400;
    padding: 0;
    line-height: 18px;
  }
`);

export const ListStatus = {
  PENDING: "PENDING",
  ENGAGED: "ENGAGED",
  COMPLETED: "COMPLETED"
};

const UseReward = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [isScanQr, setIsScanQr] = useState(false);
  const id = location.pathname.split("/")[2];
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState(location.state ? location.state.type : null);
  const [customerSubcampaignId, setCustomerSubcampaignId] = useState(
    location.state ? location.state.customer_subcampaign_id : 0
  );
  const [isLoadedStatus, setIsLoadedStatus] = useState(true);
  const initialData = {
    coupon_code: "",
    qrscan_image: "",
    reward_banner: "",
    used_at: "",
    expired_at: "",
    coupon_used_option: "",
    is_3rdparty_coupon_use: false,
    is_for_verified_users: false,
    is_line_verified: false,
    remain_quantity: 0,
    is_expired_or_finished_issued: false,
    banner_image_corner: "0",
  };
  const [data, setData] = useState(initialData);
  const [used, setUsed] = useState(false);
  const [isExpired, setIsExpired] = useState(true);
  const goToRewardList = (use?: boolean) => {
    setIsScanQr(false);
    window.location.replace(links.EARN_PAGE + (use ? "?tab=1" : ""));
  };
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogInfo, setDialogInfo] = useState({
    is_success: false,
    coupon_code: ""
  });

  useEffect(() => {
    if (location.pathname.includes("use-reward")) {
      const searchParams = new URLSearchParams(location.search);
      let session_id = "";
      if (searchParams) {
        if (searchParams.get("session_id")) {
          session_id = JSON.parse(atob(searchParams.get("session_id") || ""))["session_id"];
        }
        if (customerSubcampaignId) {
          localStorage.setItem(`subcampaign_id_${id}`, customerSubcampaignId);
        } else if (searchParams.get("customer_subcampaign_id")) {
          localStorage.setItem(`subcampaign_id_${id}`, searchParams.get("customer_subcampaign_id") || "0");
          setCustomerSubcampaignId(searchParams.get("customer_subcampaign_id"));
        } else {
          setCustomerSubcampaignId(localStorage.getItem(`subcampaign_id_${id}`));
        }
      }
      if (!localStorage.getItem("session-id")) {
        localStorage.setItem("session-id", session_id);
      }
      if (localStorage.getItem("session-id")) {
        localStorage.setItem("subcampaign_id", id);
        postEngageAction({ subcampaign_id: toInteger(id), isCouponPage: true });
      }
      navigate(links.USE_REWARD.replace(":id", id));
    }
  }, []);

  useEffect(() => {
    const handlePopState = (event: any) => {
      if (location.state?.fromPath !== "EARN_REWARD") {
        window.history.pushState(null, "", window.location.pathname);
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate, location]);

  useEffect(() => {
    if (!status) {
      setIsLoadedStatus(false);
      if (localStorage.getItem("session-id")) {
        let customer_subcampaign_id = parseInt(localStorage.getItem(`subcampaign_id_${id}`) || "0");
        getCustomerSubcampaignStatus(({ id: id, is_use_page: true, customer_subcampaign_id: customer_subcampaign_id })).then((statusData: any) => {
          if (statusData?.status) {
            setStatus(statusData.status);
            setIsLoadedStatus(true);
          }
        });
      }
    }
  }, []);

  useEffect(() => {
    if (isLoadedStatus && status) {
      getAdsDetail({ id: id, type: status, customer_subcampaign_id: customerSubcampaignId, isRewardPage: true }).then((detailData: any) => {
        setData(detailData);
        if (status === ListStatus.COMPLETED) {
          setUsed(true);
        }
        if (detailData?.expired_at) {
          setIsExpired(isExpiredToday(detailData?.expired_at));
        }
        const sendingMessagePlatform = detailData?.sending_message_platform || process?.env?.REACT_APP_DEFAULT_APPLICATION;
        if (
          typeof sendingMessagePlatform === "string" &&
          [
            LOGIN_METHOD.LINE_SESSION_ID,
            LOGIN_METHOD.LINE_PHONE_NUMBER,
            LOGIN_METHOD.LINE_ADCOINZ_PHONE_NUMBER,
            LOGIN_METHOD.LINE_SSO,
            LOGIN_METHOD.LINE_ADCOINZ_SESSION_ID,
            LOGIN_METHOD.LINE_TW
          ].includes(sendingMessagePlatform) &&
          detailData?.is_for_verified_users &&
          !detailData?.is_line_verified &&
          (status === ListStatus.PENDING || status === ListStatus.ENGAGED)
        ) {
          localStorage.removeItem("otp-page-expired");
          localStorage.removeItem("otp-phone-verified");
          navigate(links.OTP_INSERT_PHONE_NUMBER, { state: { ...location.state, otp_use_only__subcampaign_id: id } });
        }
        setIsLoading(false);
      }).catch((err) => {
        if (err?.response?.data?.error_code === "COUPON_FAILED") {
          navigate(`${links.SMART_RETAIL_ERROR}?error-msg=coupon_failed`);
        }
        else {
          setIsLoading(false);
        }
      });
    }
  }, [isLoadedStatus, status]);

  useEffect(() => {
    if (data && data.is_3rdparty_coupon_use && (!data?.is_for_verified_users || data?.is_line_verified)) {
      if (isURL(data.coupon_code)) {
        window.location.href = data.coupon_code;
      }
      else {
        navigate(`${links.SMART_RETAIL_ERROR}?error-msg=invalid_url`);
      }
    }
  }, [data]);

  const onCam = () => {
    setIsScanQr(true);
  };

  const offCam = () => {
    setIsScanQr(false);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const setDialogInformation = (dialogInformation: any) => {
    setDialogInfo({
      ...dialogInformation,
      coupon_code: data?.coupon_code
    });
  };

  const barcode = (
    <Barcode
      value={data?.coupon_code ?? ""}
      marginBottom={20}
      displayValue={false}
      lineColor={(used || isExpired) ? "#DADADA" : "#42436A"}
      width={1.4}
      height={70}
    />
  );

  const qrcode = (
    <QRCode
      size={172}
      value={data?.coupon_code ?? ""}
      viewBox={"0 0 256 256"}
      fgColor={(used || isExpired) ? "#DADADA" : "#42436A"}
    />);

  const getCouponDisplayMode = () => {
    const couponUsedOption = data?.coupon_used_option;
    switch (couponUsedOption) {
      case "BARCODE":
        return (
          <Barcode
            value={data?.coupon_code ?? ""}
            marginBottom={40}
            marginTop={50}
            displayValue={false}
            lineColor={(used || isExpired) ? "#DADADA" : "#42436A"}
            width={((data?.coupon_code?.length > 10) ? 1.4 : 1.8)}
            height={100}
          />
        );
      case "QRCODE":
        return qrcode;
      case "BARCODE_QRCODE":
        return (
          <>
            {barcode}
            {qrcode}
          </>
        );
    }
  };


  return (
    isScanQr
      ? (
        <>
          <QRScanner
            coupon_code={data?.coupon_code}
            setDialogInformation={setDialogInformation}
            handleDialogOpen={handleDialogOpen}
            offCam={offCam}
          />
          {
            openDialog
              ? (
                <QRCodeScanDialog
                  open={openDialog}
                  offCam={offCam}
                  onClose={handleDialogClose} {...dialogInfo}
                />
              )
              : ""
          }
        </>
      )
      : (
        <>
          <AuthenticateLayout
            background={data?.reward_banner}
            isLoading={isLoading}
            // button={RewardButton}
            bannerImageCorner={data?.banner_image_corner}
          >
            {isLoading && <Loading />}
            <UseRewardWrapper>
              <Box className="body" sx={{ left: 0, top: 118 }}>
                <QRCodeWrapper>
                  {(!data?.coupon_used_option || data?.is_3rdparty_coupon_use) && <Loading customBackgroundColor="rgba(255,255,255,1)" />}
                  {
                    data?.coupon_used_option === "QRSCANNER_FROM_CAMERA" ?
                      !data.qrscan_image ? <Loading /> : (
                        <Grid mt={0.5} container justifyContent="center">
                          <img
                            src={data?.qrscan_image}
                            alt="reward_banner"
                            style={
                              {
                                width: "100%",
                                height: "auto",
                                // Based on the width of <QRCodeWrapper>, QR Scanner Image's aspect ratio is 1:1, 720px x 720px
                                maxHeight: "calc(333px - 20px)"
                              }
                            }
                          />
                        </Grid>
                      )
                      : (
                        <>
                          <TnC />
                          <Grid mt={0.5} container justifyContent="center">
                            <Typography
                              mr={0.5}
                              sx={{ fontSize: 14, color: "#8D8D8D", fontWeight: 400 }}
                            >
                              {used ? t("usedDate") : t("expiredDate")}
                            </Typography>
                            <ExpiredDate
                              sx={{ fontSize: 14, fontWeight: 400 }}
                            >
                              {used ? commonDateFormat(moment(data?.used_at)) : commonDateFormat(moment(data?.expired_at))}
                            </ExpiredDate>
                          </Grid>
                          {getCouponDisplayMode()}
                          <Typography
                            mt={1}
                            sx={{ fontSize: 14, color: "#8D8D8D", fontWeight: 400 }}
                          >
                            {t("yourRedeemCode")}
                          </Typography>
                          <RedeemCode
                            mt={1}
                            sx={{ color: isExpired ? "#DADADA" : "#000000" }}
                          >
                            {data?.coupon_code}
                          </RedeemCode>
                        </>
                      )
                  }
                </QRCodeWrapper>
                <Box className="footerBox">
                  {
                    !used && !isExpired && !isScanQr && (
                      <Typography
                        sx={
                          {
                            marginBottom: 3,
                            color: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__COUPON_CAN_BE_USED_N_TIMES_TEXT_COLOR || "#000000"
                          }
                        }
                        className="notice_text"
                      >
                        <span className="notice">*</span>
                        {t("couponBalanceMsg1") + " " + data?.remain_quantity + " " + t("couponBalanceMsg2")}
                      </Typography>
                    )
                  }
                  {
                    !used && !isExpired ? (
                      <ScanToRedeemButton
                        startIcon={<SVG src={GiftIcon} />}
                        variant="contained"
                        onClick={!used ? onCam : undefined}
                        style={{
                          ...(
                            process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__SCAN_QR_TO_REDEEM_BUTTON_BACKGROUND_COLOR
                              ? { backgroundColor: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__SCAN_QR_TO_REDEEM_BUTTON_BACKGROUND_COLOR }
                              : {}
                          ),
                          ...(
                            process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__SCAN_QR_TO_REDEEM_BUTTON_TEXT_COLOR
                              ? { color: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__SCAN_QR_TO_REDEEM_BUTTON_TEXT_COLOR }
                              : {}
                          )
                        }}
                      >
                        {t("scanToRedeem")}
                      </ScanToRedeemButton>
                    ) : ""
                  }
                  <Grid container mt={2}>
                    {
                      !used && !isExpired && <Grid item xs={6}>
                        <ViewMoreBtn
                          onClick={() => goToRewardList(true)}
                          fullWidth
                          variant="contained"
                          style={{
                            ...(
                              process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__USE_LATER_BUTTON_BACKGROUND_COLOR
                                ? { backgroundColor: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__USE_LATER_BUTTON_BACKGROUND_COLOR }
                                : {}
                            ),
                            ...(
                              process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__USE_LATER_BUTTON_TEXT_COLOR
                                ? { color: process.env.REACT_APP__UI_CUSTOMIZATION__USE_REWARD_PAGE__USE_LATER_BUTTON_TEXT_COLOR }
                                : {}
                            )
                          }}
                        >
                          {t("useLater")}
                        </ViewMoreBtn>
                      </Grid>
                    }

                    <Grid item xs={(used || isExpired) ? 12 : 6}>
                      <ReportErrorLink />
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </UseRewardWrapper>
          </AuthenticateLayout>
        </>
      )
  );
};

export default UseReward;
